define('SearchInBanner.View', [
    'searchinbanner.tpl',
    'Backbone',
    'jQuery'
], function SearchInBannerView(
    searchInBannerTpl,
    Backbone,
    jQuery
) {
    'use strict';

    return Backbone.View.extend({
        template: searchInBannerTpl,
        initialize: function initialize(options) {
            this.application = options.container;
            this.isEnable = options.config.enable;
            this.bannerLink = options.config.homePageLink;
            this.maxLength = options.maxLength;
            this.defaultSearchUrl = options.defaultSearchUrl;

        },
        events: {
            'submit [data-action="search-in-banner"]': 'searchInBannerEventHandler'
        },
        searchInBannerEventHandler: function searchInBannerEventHandler(e) {
            var searchTerm;
            e.preventDefault();
            searchTerm = jQuery.trim(this.$el.find('[data-type="search-in-banner-input"]').val());
            if (searchTerm && searchTerm.length) {
                this.executeSearch(searchTerm);
            }
        },
        executeSearch: function executeSearch(keywords) {
            var self = this;
            var plpComponent;
            if (keywords) {
                plpComponent = this.application && this.application.getComponent('PLP');
                if (!plpComponent) {
                    self.runSearch(keywords);
                } else {
                    plpComponent.setSearchText({
                        searchText: keywords
                    }).fail(function fail() {
                        self.runSearch(keywords);
                    });
                }
            }
        },
        runSearch: function runSearch(keywords) {
            var searchUrl = this.defaultSearchUrl;
            var keywordsDelimited = '?keywords=';

            Backbone.history.navigate(searchUrl + keywordsDelimited + keywords, {
                trigger: true
            });
        },
        getContext: function getContext() {
            return {
                enable: this.isEnable,
                maxLength: this.maxLength,
                bannerLink: this.bannerLink
            };
        }
    });
});
